import BillingStore from 'billing/BillingStore'
import BillingMethod from 'billing/models/BillingMethod'
import { SetupIntent } from 'billing/models/SetupIntent'
import { CardPaymentMethodEditorPorts } from 'billing/payment-methods/ports'
import Member from 'iam/models/Member'
import Team from 'iam/models/Team'

/**
 * Adapter that implements the functionality needed for the Card Payment
 * Method Editor.
 */
export default function CardPaymentMethodEditorAdapter(
  billingStore: BillingStore,
  stripePk: string,
): CardPaymentMethodEditorPorts {
  return {
    getStripePublishableKey: () => stripePk,
    setupStripePaymentMethodIntent: async (
      member: Member,
      team: Team | undefined | null,
    ): Promise<SetupIntent> => {
      return billingStore.setupStripePaymentMethodIntent(member, team)
    },
    completeSetupStripePaymentMethodIntent: async (
      setupIntentId: string,
      member: Member,
      team: Team | undefined | null,
    ): Promise<BillingMethod> => {
      return billingStore.completeSetupStripePaymentMethodIntent(
        setupIntentId,
        member,
        team,
      )
    },
    createBillingMethod: async (
      member: Member,
      team: Team | null,
      token: string,
    ): Promise<BillingMethod> => {
      return billingStore.addBillingMethodForStripeToken(member, team, token)
    },
  }
}
